import { useState } from 'react';

interface Props {
  domanda: string;
  etichettaConferma?: string;
  inCorso?: boolean;
  onConferma: (motivo: string) => void;
  onAnnulla: () => void;
}

/**
 * Chiede il perché di un'azione che il dominio non accetta senza spiegazione: chiudere un
 * residuo, annullare un documento, respingere della merce.
 *
 * È un pezzo di interfaccia e non un `window.prompt` per tre motivi: un prompt del browser
 * non si può stilare né tradurre, non dice a quale riga si riferisce, e blocca la pagina —
 * cosa che rende impossibile provare la schermata con un'automazione.
 *
 * Il motivo vuoto lo rifiuta anche il dominio; dirlo qui evita un giro di rete per
 * scoprire una cosa che si sapeva già.
 */
export function ChiediMotivo({
  domanda,
  etichettaConferma = 'Conferma',
  inCorso = false,
  onConferma,
  onAnnulla,
}: Props) {
  const [motivo, setMotivo] = useState('');
  const pronto = motivo.trim().length > 0;

  return (
    <form
      className="chiedi-motivo"
      onSubmit={(e) => {
        e.preventDefault();
        if (pronto && !inCorso) onConferma(motivo.trim());
      }}
    >
      <label>
        {domanda}
        <input
          type="text"
          autoFocus
          value={motivo}
          disabled={inCorso}
          onChange={(e) => setMotivo(e.target.value)}
          onKeyDown={(e) => e.key === 'Escape' && onAnnulla()}
        />
      </label>
      <div className="azioni">
        <button type="button" disabled={inCorso} onClick={onAnnulla}>
          Lascia stare
        </button>
        <button type="submit" className="primario" disabled={!pronto || inCorso}>
          {inCorso ? '…' : etichettaConferma}
        </button>
      </div>
    </form>
  );
}
